import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
  HostListener,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';

@Component({
  selector: 'prime-image-fullscreen-viewer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './fullscreen-image-viewer.component.html',
  styleUrls: ['./fullscreen-image-viewer.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullscreenImageViewerComponent {
  @Output() closeViewer = new EventEmitter<never>();
  _image = '';

  @Input()
  set image(img: string) {
    this._image = img;
  }

  get image(): string {
    return this._image;
  }

  close(): void {
    this.closeViewer.emit();
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event && event.key) {
      if (event.key.toLowerCase() === 'escape') {
        this.close();
      }
    }
  }
}
